import { render, staticRenderFns } from "./StudentAccounts.vue?vue&type=template&id=e39f669a&scoped=true"
import script from "./StudentAccounts.vue?vue&type=script&lang=js"
export * from "./StudentAccounts.vue?vue&type=script&lang=js"
import style0 from "./StudentAccounts.vue?vue&type=style&index=0&id=e39f669a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f669a",
  null
  
)

export default component.exports